import React from 'react';
import {toArray} from 'react-emoji-render';

function parseEmojisAndHtml(value) {
  const innerHTMLArray = toArray(value);
  const innerHTMLOutput = innerHTMLArray.map((element, index) => {
    if (typeof element === 'string') {
      return <span key={index} dangerouslySetInnerHTML={{__html: element}} />;
    }
    return element.props.children;
  });
  return innerHTMLOutput;
}

export default parseEmojisAndHtml;
